import { Auto, Bike, Bus, Walk } from '@eventbrite/eds-iconography';
import React, { ReactElement } from 'react';
import { GACodes } from '../../types';

/**
 * Config Options for the Map and Marker components
 */
const svgMarker =
    '<svg width="38" height="57" viewBox="0 0 38 57" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="a"><feGaussianBlur stdDeviation="3 0" in="SourceGraphic"/></filter><path d="M18.8860735 0C8.61100338 0 .25126726 7.98542124.25126726 17.7998965c0 3.2495066.92687906 6.4298405 2.69475502 9.2208772L18.2298042 49.5147594c.1490785.221996.4018637.3539067.6708531.3539067.2706097 0 .5217745-.1335194.6724734-.3555153L34.8488105 26.985383c1.748431-2.765298 2.6720692-5.9424146 2.6720692-9.1854865C37.5208797 7.98542124 29.1611436 0 18.8860735 0z" id="b"/><filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="c"><feGaussianBlur stdDeviation="2" in="SourceAlpha" result="shadowBlurInner1"/><feOffset dy="-2" in="shadowBlurInner1" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 0.450980392 0 0 0 0 0.176470588 0 0 0 0 0.0901960784 0 0 0 0.2 0" in="shadowInnerInner1"/></filter><path d="M26.369446 18.3953073c0 3.9134615-3.1611233 7.09925-7.0481092 7.09925s-7.0497933-3.1857885-7.0497933-7.09925c0-3.9152365 3.1628074-7.0992501 7.0497933-7.0992501s7.0481092 3.1840136 7.0481092 7.0992501z" id="d"/><filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="e"><feGaussianBlur stdDeviation="1" in="SourceAlpha" result="shadowBlurInner1"/><feOffset dy="2" in="shadowBlurInner1" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 0.349019608 0 0 0 0 0.137254902 0 0 0 0 0.0705882353 0 0 0 0.2 0" in="shadowInnerInner1"/></filter></defs><g fill="none" fill-rule="evenodd"><path d="M19.0817717 56.5765766c3.0827274 0 5.5817717-1.9199321 5.5817717-4.2882883C24.6635434 49.9199321 22.1644991 48 19.0817717 48S13.5 49.9199321 13.5 52.2882883c0 2.3683562 2.4990443 4.2882883 5.5817717 4.2882883z" fill-opacity=".13" fill="#282C35" filter="url(#a)"/><g><use fill="#F86820" xlink:href="#b"/><use fill="#000" filter="url(#c)" xlink:href="#b"/></g><g><use fill="#BF4C28" xlink:href="#d"/><use fill="#000" filter="url(#e)" xlink:href="#d"/></g></g></svg>';
export const G_MAPS_LINK = 'https://maps.google.com?saddr=Current+Location';
export const markerOptions: google.maps.MarkerOptions = {
    icon: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgMarker),
};
export const mapOptions: google.maps.MapOptions = {
    styles: [
        {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#f5f5f5',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text',
            stylers: [
                {
                    lightness: '15',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    lightness: '-11',
                },
            ],
        },
        {
            featureType: 'administrative.neighborhood',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#f5f5f5',
                },
                {
                    lightness: '-1',
                },
            ],
        },
        {
            featureType: 'landscape.natural.terrain',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'poi.business',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    lightness: 20,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'simplified',
                },
                {
                    color: '#ffffff',
                },
                {
                    lightness: '15',
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'simplified',
                },
                {
                    lightness: '0',
                },
                {
                    hue: '#ff6500',
                },
            ],
        },
        {
            featureType: 'road.highway.controlled_access',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'simplified',
                },
                {
                    color: '#ffffff',
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    color: '#ffffff',
                },
                {
                    lightness: '0',
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    lightness: '28',
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    lightness: '15',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'all',
            stylers: [
                {
                    hue: '#007bff',
                },
                {
                    saturation: 30,
                },
                {
                    lightness: 49,
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#39c2c9',
                },
                {
                    saturation: '-20',
                },
                {
                    gamma: '1.00',
                },
                {
                    lightness: '46',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
    ],
    mapTypeControl: false,
    minZoom: 7,
    maxZoom: 18,
};
interface ButtonConfig {
    icon: ReactElement;
    ariaLabel: string;
    queryParams: {
        mode?: string;
        dirflg?: string;
    };
    label: string;
}
export const buttonsConfig: ButtonConfig[] = [
    {
        icon: <Auto />,
        ariaLabel: 'Driving directions',
        queryParams: {
            mode: 'driving',
        },
        label: GACodes.GA_LABEL_DRIVE,
    },
    {
        icon: <Walk />,
        ariaLabel: 'Walking directions',
        queryParams: {
            dirflg: 'w',
        },
        label: GACodes.GA_LABEL_WALK,
    },
    {
        icon: <Bus />,
        ariaLabel: 'Transit directions',
        queryParams: {
            mode: 'transit',
            dirflg: 'r',
        },
        label: GACodes.GA_LABEL_BUS,
    },
    {
        icon: <Bike />,
        ariaLabel: 'Cycling directions',
        queryParams: {
            mode: 'bicycling',
            dirflg: 'b',
        },
        label: GACodes.GA_LABEL_BIKE,
    },
];
